export default Object.freeze(['yellow', 'red', 'blue', 'black']);



/** WEBPACK FOOTER **
 ** ./src/constants/diseases.js
 **/